<template>
  <div class="api-key-user-table-cell">
    <div class='api-key-user-table-cell__name'>
      {{ formattedName }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'ApiKeyUserTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedName() {
      if (this.item.user.firstName && this.item.user.lastName) {
        return `${this.item.user.lastName} ${this.item.user.firstName}`;
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.api-key-user-table-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__name {
    text-transform: capitalize;
  }
}
</style>
